import { render, staticRenderFns } from "./GetChainStore.vue?vue&type=template&id=4ba0a030&"
import script from "./GetChainStore.vue?vue&type=script&lang=js&"
export * from "./GetChainStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports